/** Where an alert takes you: the meeting, the diary entry it names, or whatever it linked to. */
export const destinationOf = (n) => {
  if (n.link?.startsWith("http")) return { kind: "external", to: n.link, label: "Join now" };
  if (n.event_id && n.date)
    return {
      kind: "entry",
      to: `/calendar?view=day&date=${n.date}&entry=${n.event_id}`,
      label: "Open the entry",
    };
  if (n.link?.startsWith("/matters/"))
    return { kind: "matter", to: n.link, label: "Open the matter" };
  if (n.link) return { kind: "page", to: n.link, label: "Open" };
  return null;
};

export const ALERT_GROUPS = [
  { key: "", label: "Everything" },
  { key: "listings", label: "Listings" },
  { key: "todos", label: "To-dos" },
  { key: "notes", label: "Notes & dictation" },
  { key: "digests", label: "Briefs & digests" },
];

const LABELS = {
  alert: "Listing",
  meeting: "Meeting",
  event: "Diary entry",
  clash: "Clash",
  clash_manual: "Clash",
  todo: "To-do",
  todo_rollover: "Roll over",
  todo_rollover_manual: "Roll over",
  due_today: "Due today",
  due_today_manual: "Due today",
  postit: "Post-it",
  postit_expiry: "Post-it lapsing",
  postit_expiry_manual: "Post-it lapsing",
  voice_log: "Dictated note",
  voice_brief: "Voice brief",
  voice_review: "To read",
  voice_review_manual: "To read",
  brief: "Morning brief",
  brief_manual: "Morning brief",
  overview: "Overview",
  uncategorized: "Uncategorized",
  uncategorized_manual: "Uncategorized",
};

export const kindLabel = (kind) => LABELS[kind] || (kind || "").replace(/_/g, " ");
